import React, { useEffect, useMemo } from 'react';
import LargeCard from '../main/large-card';
import useTranslate from '../useTranslate';
import { usePbDispatch, usePbSelector } from '../../store/pbStoreHooks';
import {
    LoadPartnerInvoices,
    PartnerInvoiceDto,
} from '../../store/partnerInvoiceSlice';
import PartnerInvoicesGroup from './partner-invoices-group';

interface GroupedInvoices {
    [year: number]: PartnerInvoiceDto[];
}

function PartnerInvoicesCard() {
    const strings = useTranslate('PartnerInvoices');
    const dispatch = usePbDispatch();
    const requestData = usePbSelector(
        (state) => state.partnerInvoice.partnerInvoices
    );

    const data: GroupedInvoices = useMemo(() => {
        if (!requestData) {
            return {};
        }
        const result: GroupedInvoices = {};
        requestData.partner_invoices.forEach((it) => {
            if (result[it.year]) {
                result[it.year].push(it);
            } else {
                result[it.year] = [it];
            }
        });
        return result;
    }, [requestData]);

    useEffect(() => {
        dispatch(LoadPartnerInvoices());
    }, []);

    return (
        <LargeCard type={'card-edit'} title={strings.title}>
            {Object.keys(data).length === 0 && <p>{strings.noInvoices}</p>}
            {Object.keys(data)
                .toSorted((a, b) => b.localeCompare(a))
                .map((year) => (
                    <PartnerInvoicesGroup
                        key={year}
                        year={Number.parseInt(year)}
                        invoices={data[Number.parseInt(year)]}
                    />
                ))}
        </LargeCard>
    );
}

export default PartnerInvoicesCard;
